import _map from 'lodash/map';
import _cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';

import initialState from './initialState';
import actionType from './actionTypes';

const ddConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_DD_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                ddConfigurations: action.payload,
                gridDDConfigurations: _cloneDeep({
                    fielddata: initialState.gridDDConfigurations.fielddata,
                    instances: _map(action.payload, (config) => ({
                        ...config,
                        id: uuidv4(),
                        filing_date: null,
                        // created_date : moment(config.created_date, "YYYY MM DD")
                    })),
                }),
                fieldNames: _map(action.payload, 'field_name'),
            };
        }
        case actionType.GET_DD_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                ddConfig: {},
            };
        }
        case actionType.GET_ALL_DD_CONFIGURATION_SUCCESS_LINKED: {
            return {
                ...state,
                ddConfigurationsLinked: action.payload,
            };
        }
        case actionType.GET_ALL_DEFAULT_DICTIONARIES_SUCCESS: {
            return {
                ...state,
                defaultDictionaries: action.payload,
            };
        }
        case actionType.GET_DD_PENDING_FILE_UPLOADS: {
            return {
                ...state,
                ddFilesPendingApproval: action.payload,
            };
        }
        default:
            return state;
    }
};

export default ddConfigurationReducer;
